module.exports = __webpack_public_path__ + "static/media/logo-alt.6a95c75b.svg";